import { DomainProbeStatus } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Text } from '@tribeplatform/react-ui-kit/Text'

interface Props {
  domain: string
  status: DomainProbeStatus
}

export const StatusError = ({ domain, status }: Props) => (
  <div className="flex flex-col items-center">
    <Text variant="bodyLg" fontWeight="bold">
      <T
        id="Admin.Settings.Domain.TransferError"
        defaultMessage="Something went wrong while transferring your domain"
      />
    </Text>
    <Text variant="bodySm">
      <T
        id="Admin.Settings.Domain.TransferError.Subtitle"
        defaultMessage="Please cancel the transfer and retry the process. If the issue persists, contact Bettermode support."
      />
    </Text>
    <details className="text-xs p-2">
      <summary className="text-center cursor-pointer">
        <T id="Generics.ClickForDetails" defaultMessage="Click for details" />
      </summary>
      <pre className="text-xs mt-2 p-2 bg-surface-subdued rounded-lg">
        {/* Technical info. Doesn’t need translation */}
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <span>{`To: ${domain}, Status: ${status}`}</span>
      </pre>
    </details>
  </div>
)
